export const AVATARS = [
  { key: 'default', label: '默认' },
  { key: 'mountain', label: '山川' },
  { key: 'compass', label: '指南针' },
  { key: 'book', label: '笔记' },
  { key: 'sun', label: '朝阳' },
] as const
export type AvatarKey = (typeof AVATARS)[number]['key']
export const avatarKey = (value?: string): AvatarKey => AVATARS.find(item => item.key === value)?.key ?? 'default'
